import { Document, Page, PDFViewer, StyleSheet } from "@react-pdf/renderer";
import { Circle } from "../../components/Animation";
import { Request } from "../../hooks/Request";
import { validateArray } from "../../utils/validate";
import { MyDocClearanceForm } from "./MyDocClearanceForm";

const transformData = (data) => {
  const totalTributos =
    data?.["a-TributosYOtrosConceptosAduanerosSubDatas"] &&
    validateArray(data?.["a-TributosYOtrosConceptosAduanerosSubDatas"])
      ? data?.["a-TributosYOtrosConceptosAduanerosSubDatas"].reduce(
          (sum, e) => sum + Number(e.description || 0),
          0
        )
      : 0;

  const totalErogaciones =
    data?.["b-OtrosGastosDeImportacion/ExportacionSubDatas"] &&
    validateArray(data?.["b-OtrosGastosDeImportacion/ExportacionSubDatas"])
      ? data?.["b-OtrosGastosDeImportacion/ExportacionSubDatas"].reduce(
          (sum, e) => sum + Number(e.description || 0),
          0
        )
      : 0;

  const totalHonorarios =
    data?.["c-GastosDeOperacionesSubDatas"] &&
    validateArray(data?.["c-GastosDeOperacionesSubDatas"])
      ? data?.["c-GastosDeOperacionesSubDatas"].reduce(
          (sum, e) => sum + Number(e.description || 0),
          0
        )
      : 0;

  const totalGeneral = totalTributos + totalErogaciones + totalHonorarios;

  return {
    numero: data?.codigoDeInterno || "",
    fecha: {
      dim: data.fechaPagoDeLaDim || "",
      planilla: data.fechaDePlanilla || "",
      // dim: data.procFechaDeInicio
      //   ? new Date(data.procFechaDeInicio).toLocaleDateString()
      //   : "",
      // planilla: new Date().toLocaleDateString(),
    },
    cliente: {
      nombre: data.company.razonSocial || "",
      direccion: data.company.direccion || "",
      email: data.company.email || "",
      hojaTrabajo: data.codigoDeInterno ?? "",
    },
    declaracion: {
      nroRegistro: data.a1NúmeroDeDeclaración || "-",
      regimenAduanero: data.asignarRégimenDeImportación || "-",
      aduanaDespacho: data.a4AduanaDeDespacho || "-",
      valoCif: data.f10TotalValorCifAduana || "-",
      canal: data["canal(Rojo,AmarilloOVerde)"] || "-",
    },
    descripcionMercadria: data.descripciónDeLaMercancía || "-",
    tributos:
      data?.["a-TributosYOtrosConceptosAduanerosSubDatas"] &&
      validateArray(data?.["a-TributosYOtrosConceptosAduanerosSubDatas"])
        ? data?.["a-TributosYOtrosConceptosAduanerosSubDatas"]
            .map((e) => ({
              desc: e.label,
              importe: Number(e.description) || 0,
            }))
            .filter((h) => h.importe > 0)
        : [],
    erogaciones:
      data?.["b-OtrosGastosDeImportacion/ExportacionSubDatas"] &&
      validateArray(data?.["b-OtrosGastosDeImportacion/ExportacionSubDatas"])
        ? data?.["b-OtrosGastosDeImportacion/ExportacionSubDatas"]
            .map((e) => ({
              desc: e.label,
              importe: Number(e.description) || 0,
            }))
            .filter((h) => h.importe > 0)
        : [],
    honorarios:
      data?.["c-GastosDeOperacionesSubDatas"] &&
      validateArray(data?.["c-GastosDeOperacionesSubDatas"])
        ? data?.["c-GastosDeOperacionesSubDatas"]
            .map((e) => ({
              desc: e.label,
              importe: Number(e.description) || 0,
            }))
            .filter((h) => h.importe > 0)
        : [],
    // Valores calculados para los totales
    totalGeneral: totalGeneral,
    tributosImportador: totalTributos,
    anticipoImportador: 0, // No hay este dato en los originales
    saldoContable: totalGeneral - totalTributos, // Asumiendo que el anticipo es 0
  };
};
const listData = [
  "internCode",
  "codigoDeInterno",
  "nroCotizacion",
  "modalidadDeDespacho",
  "descripciónDeLaMercancía",
  "partidaArancelaria",
  "valoresNominales",
  "asignarRégimenDeImportación",
  "a1NúmeroDeDeclaración",
  "f10TotalValorCifAduana",
  //
  "fechaDeCotización",
  "tipoDeDespacho",
  "proveedor",
  "piNro",
  "nroBl",
  "tipoDeCambioProforma",
  "nroDeContenedor",

  "fechaPagoDeLaDim",
  "fechaDePlanilla",
  "canal(Rojo,AmarilloOVerde)",
  "a4AduanaDeDespacho",
  "nroFacturaComercial",
  //
  "a-TributosYOtrosConceptosAduaneros",
  "b-OtrosGastosDeImportacion/Exportacion",
  "c-GastosDeOperaciones",
  // "tributosAduaneros",
  // "erogaciones",
  // "honorariosProfesionales",
];

const CustomsClearancePdf = (props) => {
  const { procedure } = props;
  const { data, loading } = Request({
    urlApi: `/Procedure/${procedure.procedureId}/dataValues?${listData
      .map((field) => `fieldnames=${field}`)
      .join("&")}`,
  });

  const styles = StyleSheet.create({
    page: {
      padding: "50px 40px",
      fontSize: 8.5,
    },
  });

  if (!loading) {
    return <Circle />;
  }
  const transformedData = transformData(data);
  return (
    <>
      <PDFViewer
        style={{
          width: 900,
          height: window.innerHeight - 100,
        }}
      >
        <Document>
          <Page size="LETTER" style={styles.page}>
            <MyDocClearanceForm data={transformedData} />
          </Page>
        </Document>
      </PDFViewer>
    </>
  );
};

export default CustomsClearancePdf;
